import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environment';
import { Budget, BudgetRequest, PrognosisPdfRequest } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable()
export class BudgetsService {

  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getBudget(request: BudgetRequest): Observable<Budget> {
    return this.http
      .post<Budget>(`${environment.apiEndpoint}/contracts/budget`, request)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  // getPrognosis(request: BudgetRequest): Observable<Budget> {
  //   return this.http
  //     .post<Budget>(`${environment.apiEndpoint}/contracts/prognosis`, request)
  //     .pipe(catchError((error: any) => throwError(error.json())));
  // }

  prepareColdPrognosisReport(key: string, request: PrognosisPdfRequest): Observable<string>{
    return this.http.post<string>(`${environment.apiEndpoint}/reports/${key}/coldprognosis/download`, request); 
  }
}
